<template>
  <form class="message-form">
    <v-textarea
      class="message-form__textarea"
      :label="label"
      v-model="message"
      no-resize
      outlined
      rows="3"
      row-height="25"
      shaped
      counter
    />
    <v-btn
      @click="sendMessage"
      :disabled="message.trim() === ''"
      class="message-form__button"
      large
      outlined
      color="primary"
    >{{ btnText }}</v-btn>
  </form>
</template>

<script>
export default {
  name: "NoteForm",
  props: {
    label: String,
    btnText: String,
    send: Function,
  },
  data() {
    return {
      message: "",
    };
  },
  methods: {
    sendMessage() {
      if (this.message.trim() !== "") {
        this.send(this.message).then(() => {
          this.message = "";
        });
      }
    },
  },
};
</script>
